import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d9363b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CarsTable" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"CarsTable__header\" data-v-62d9363b><div class=\"text-center\" data-v-62d9363b>Тип авто</div><div class=\"text-center\" data-v-62d9363b></div><div class=\"text-center\" data-v-62d9363b>Кол-во авто</div><div class=\"text-center\" data-v-62d9363b>Стопы</div><div class=\"text-center\" data-v-62d9363b>Физ вес</div><div class=\"text-center\" data-v-62d9363b>Объемный вес</div></div>", 1)
const _hoisted_3 = { class: "CarsTable__body" }
const _hoisted_4 = { class: "CarsTable__icon" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CarsTable__tooltip-top" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Количество стопов - 25 шт"),
  /*#__PURE__*/_createElementVNode("p", null, "Высота - 150 см"),
  /*#__PURE__*/_createElementVNode("p", null, "Ширина - 190 см"),
  /*#__PURE__*/_createElementVNode("p", null, "Длина - 300 см"),
  /*#__PURE__*/_createElementVNode("p", null, "Вес - 1450 кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "CarsTable__triangle-down" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CarsTable__cell" }, "Грузовая", -1))
const _hoisted_7 = { class: "CarsTable__cell" }
const _hoisted_8 = { class: "CarsTable__cell" }
const _hoisted_9 = { class: "CarsTable__cell" }
const _hoisted_10 = { class: "CarsTable__cell" }
const _hoisted_11 = { class: "CarsTable__icon" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CarsTable__tooltip-bottom" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Количество стопов - 30 шт"),
  /*#__PURE__*/_createElementVNode("p", null, "Высота - 51 см"),
  /*#__PURE__*/_createElementVNode("p", null, "Ширина - 107 см"),
  /*#__PURE__*/_createElementVNode("p", null, "Длина - 75 см"),
  /*#__PURE__*/_createElementVNode("p", null, "Вес - 500 кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "CarsTable__triangle-up" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CarsTable__cell" }, "Легковая", -1))
const _hoisted_14 = { class: "CarsTable__cell" }
const _hoisted_15 = { class: "CarsTable__cell" }
const _hoisted_16 = { class: "CarsTable__cell" }
const _hoisted_17 = { class: "CarsTable__cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_car_truck = _resolveComponent("car-truck")!
  const _component_car_passenger = _resolveComponent("car-passenger")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_car_truck),
        _hoisted_5
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(Math.round(_ctx.getCarCount('T'))), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(Math.round(_ctx.getStopsCount('T'))), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(Math.round(_ctx.getWeight('T'))) + " кг", 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(Math.round(_ctx.getVolumeWeight('T'))) + " кг", 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_car_passenger),
        _hoisted_12
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, _toDisplayString(Math.round(_ctx.getCarCount('P'))), 1),
      _createElementVNode("div", _hoisted_15, _toDisplayString(Math.round(_ctx.getStopsCount('P'))), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(Math.round(_ctx.getWeight('P'))) + " кг", 1),
      _createElementVNode("div", _hoisted_17, _toDisplayString(Math.round(_ctx.getVolumeWeight('P'))) + " кг", 1)
    ])
  ]))
}